import { StepViewModel } from '../models/step';

const minimumProgress = 6;

export interface TreeNode {
  key: string;
  data: () => { key: string; value: StepViewModel };
  parentNode: () => TreeNode;
  childNodes: () => TreeNode[];
}

export const getCurrentProgress = (stepTree: any | null, step: StepViewModel): number => {
  const currentProgressNode: TreeNode = stepTree.traverser().searchBFS((data: TreeNode) => data.key === step.key);
  const progress = currentProgressNode.data().value.progress;
  if (progress) {
    return progress;
  }

  if (progress === 0) {
    return minimumProgress;
  }

  let stepsToPreviousProgress = 0;
  let previousProgressNode = currentProgressNode;
  let previousProgress = 0;
  while (previousProgressNode && !previousProgressNode.data().value.progress) {
    stepsToPreviousProgress++;
    previousProgressNode = previousProgressNode.parentNode();
  }
  if (previousProgressNode && previousProgressNode.data() && previousProgressNode.data().value) {
    const tempProgress = previousProgressNode.data().value.progress;
    previousProgress = tempProgress ? tempProgress : 0;
  }

  const nextStats = findNextProgress(currentProgressNode);

  if (!nextStats) {
    return minimumProgress;
  }

  const totalSteps = stepsToPreviousProgress + nextStats.steps + 1;
  const nextProgress = nextStats.progress;

  if (!nextProgress) {
    return minimumProgress;
  }

  const thisStepNumber = stepsToPreviousProgress + 1;
  const result = (nextProgress - previousProgress) * (thisStepNumber / totalSteps) + previousProgress;

  return result;
};

export const findNextProgress = (node: TreeNode, steps = 0): { steps: number; progress: number } | null => {
  steps++;
  const step = node.data().value;

  if (step.progress) {
    return {
      steps,
      progress: step.progress,
    };
  }

  const children = node.childNodes();
  if (!children) {
    return null;
  }

  for (const child of children) {
    const ret = findNextProgress(child, steps);
    if (ret) {
      return ret;
    }
  }

  return null;
};
